<template>
  <div
    class="fixed right-0 top-1/2 -translate-y-1/2 z-50 transition-transform duration-75 ease-in-out"
    :class="isAuthenticated && !isOpen ? 'translate-x-0' : 'translate-x-full'"
  >
    <button
      v-tooltip.left="{ value: 'Ask Audience AI', showDelay: 300, hideDelay: 100 }"
      class="flex flex-col size-11 items-center p-[10px] text-inverse cursor-pointer rounded-l-lg shadow-lg hover:brightness-90 transition-[filter] duration-150"
      style="background: linear-gradient(180deg, #9333EA 0%, #D25CFF 100%)"
      @click="open()"
    >
      <AM3Icon
        type="sparkles"
        size="lg"
        class="size-6 text-inverse"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'
import { computed } from 'vue'
import AM3Icon from '@/components/am3-generic/base/icon/AM3Icon.vue'
import { useAudienceAIPanel } from '@/composables/useAudienceAIPanel'

const store = useStore()
const isAuthenticated = computed(() => !!store.state.authModule?.account)

const { isOpen, open } = useAudienceAIPanel()
</script>
